<template>
	<div class="column">
		<Header></Header>
		<div class="colunm_main_box">
			<el-breadcrumb
				class="column_top_nav"
				separator-class="el-icon-arrow-right"
				style="font-size:14px;"
			>
				<span style="float:left;">当前位置：</span>
				<el-breadcrumb-item :to="{ path: '/' }"
					>首页</el-breadcrumb-item
				>
				<el-breadcrumb-item
					v-for="(item, index) in location"
					:key="index"
				>
					<span v-if="index != location.length - 1">{{ item }}</span>
					<span v-if="index == location.length - 1" class="active">{{
						item
					}}</span>
				</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="column_center_box">
				<!-- 左侧导航 -->
				<div class="column_l_nav_box">
					<el-input
						class="inline-input"
						v-model="state"
						placeholder="请输入专题内容"
						@keyup.enter.native="handleIconClick"
					>
						<i
							class="el-icon-search el-input__icon"
							slot="suffix"
							@click="handleIconClick"
						>
						</i>
					</el-input>
					<!-- <el-autocomplete
						class="inline-input"
						popper-class="my-autocomplete"
						v-model="state"
						:fetch-suggestions="querySearch"
						placeholder="请输入专题内容"
						@select="handleSelect"
					>
						<i
							class="el-icon-search el-input__icon"
							slot="suffix"
							@click="handleIconClick"
						>
						</i>
						<template slot-scope="{ item }">
							<div class="name">{{ item.value }}</div>
							<span class="addr">{{ item.address }}</span>
						</template>
					</el-autocomplete> -->
					<h5 class="column_l_nav_title">{{ topTitle }}</h5>
					<ul class="timelist">
						<li
							v-for="(item, index) in times"
							:key="index"
							:class="year == item ? ' redbg' : 'blackbg'"
							@click="year = item"
						>
							<p></p>
							<span class="classA">{{ item }}</span>
						</li>
					</ul>
					<img
						class="column_l_nav_img"
						src="../../assets/main/navbg.png"
						alt=""
					/>
				</div>
				<!-- 右侧显示部分 -->
				<div class="column_r_box">
					<Modes
						:currentChoose="currentChoose"
						:year="year"
						:inputContent="inputContent"
					></Modes>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';

import Header from '@/components/header';
import Footer from '@/components/footer';
import Mode1 from '@/components/mode1'; //饼图+实现搜索+列表
import Mode2 from '@/components/mode2'; //普通二级页
import Modes from './modes.vue'; //国际概览+多条件搜索
import titlebg from '@/assets/main/titlebg.png';

export default {
	props: {},
	components: {
		Header,
		Footer,
		Mode1,
		Mode2,
		Modes,
	},
	data() {
		return {
			restaurants: [],
			state: '',
			navData: [], //导航栏数据
			navData2: [], //特殊的6个栏目多请求一个导航栏数据
			topTitle: '二级栏目', //左侧导航头部标题
			currentChoose: '', //当前选中的栏目uid
			currentModel: '', //当前调用的模板1-0/1-1/1-2:国际概览,2:默认,3:碳排放
			location: [], //获取位置数据
			urlName: magic.getUrlKey('name'), //获取url的参数name
			times: [],
			year: '2023',
			inputContent: '',
		};
	},
	computed: {},
	created() {
		let _name = magic.getUrlKey('name'); //获取url的参数name
		_name ? (this.topTitle = _name) : (this.topTitle = '二级栏目');

		let _uid = magic.getUrlKey('uid'); //获取url的参数uid
		_uid ? (this.currentChoose = _uid) : '';
		// //console.log(this.urlName,'urlName');
	},
	mounted() {
		$('.column_l_nav_item .el-submenu__title').css({
			'font-size': '18px',
			color: '#8C8C8C',
		});
		setTimeout(() => {
			$('.column_l_nav_title').css(
				'background',
				"url('" + titlebg + "') no-repeat center"
			);
		}, 500);

		let _id = magic.getUrlKey('id'); //获取url的参数id
		// _id ? this.fetchNavList(_id) : (widnow.location.href = '/index.html');

		let _name = magic.getUrlKey('name'); //获取url的参数name

		// this.fetchLoaction(_id);
		// this.restaurants = this.loadAll();
		this.getTimes();
	},
	methods: {
		//获取导航数据
		fetchLoaction(_id) {
			let _this = this;
			// api.getMenu(_id).then((res) => {
			// 	_this.location = res.data.reverse();
			// });
		},
		getTimes() {
			api.getYearListByChnId({ chnid: 7392, topNumber: 100 }).then(
				(res) => {
					this.times = res.data;
					this.year = res.data[0];
				}
			);
		},

		//input搜索
		querySearch(queryString, cb) {
			var restaurants = this.restaurants;
			var results = queryString
				? restaurants.filter(this.createFilter(queryString))
				: restaurants;
			// 调用 callback 返回建议列表的数据
			cb(results);
		},
		//获取数据
		loadAll() {
			return [
				{},
				// { value: '三全鲜食（北新泾店）', address: '长宁区新渔路144号' },
				// {
				// 	value: 'Hot honey 首尔炸鸡（仙霞路）',
				// 	address: '上海市长宁区淞虹路661号',
				// },
				// {
				// 	value: '新旺角茶餐厅',
				// 	address: '上海市普陀区真北路988号创邑金沙谷6号楼113',
				// },
			];
		},
		createFilter(queryString) {
			return (restaurant) => {
				return (
					restaurant.value
						.toLowerCase()
						.indexOf(queryString.toLowerCase()) === 0
				);
			};
		},
		//选项
		handleSelect(item) {
			//console.log(item);
			//console.log(this.state);
			this.inputContent = this.state;
		},
		//点击选项
		handleIconClick(ev) {
			// //console.log(ev);
			//console.log(this.state);
			this.inputContent = this.state;
		},
		//获取导航数据
		fetchNavList(_id) {
			let _this = this;

			// api.getNavList(_id).then((res) => {
			// 	_this.navData = res.data;

			// 	if (res.data.length > 0) {
			// 		let _uid = magic.getUrlKey('uid'); //获取url的参数uid
			// 		let _showType = magic.getUrlKey('showType'); //获取url的参数showType
			// 		//console.log(_uid, _showType, 'test');
			// 		if (!_uid) {
			// 			//没有UID就默认选中第一个

			// 			if (res.data[0].childrenList.length > 0) {
			// 				if (
			// 					res.data[0].childrenList[0].childrenList
			// 						.length > 0
			// 				) {
			// 					_this.currentChoose =
			// 						res.data[0].childrenList[0].childrenList[0].uid;
			// 					_this.currentModel =
			// 						res.data[0].childrenList[0].childrenList[0].showType;
			// 				} else {
			// 					_this.currentChoose =
			// 						res.data[0].childrenList[0].uid;
			// 					_this.currentModel =
			// 						res.data[0].childrenList[0].showType;
			// 				}
			// 				//console.log(
			// 					_this.currentModel,
			// 					'_this.currentModel1'
			// 				);
			// 			} else {
			// 				_this.currentChoose = res.data[0].uid;
			// 				_this.currentModel = res.data[0].showType;
			// 				//console.log(
			// 					_this.currentModel,
			// 					'_this.currentModel2'
			// 				);
			// 			}
			// 		} else {
			// 			if (_showType != null) {
			// 				//点击政策速递一级的进入页面显示
			// 				_this.currentModel = _showType;
			// 				_this.currentChoose = _uid;
			// 				//console.log(
			// 					_this.currentModel,
			// 					'_this.currentModel5'
			// 				);
			// 			} else {
			// 				for (let i = 0; i < res.data.length; i++) {
			// 					if (res.data[i].uid == _uid) {
			// 						_this.currentModel = res.data[i].showType;
			// 						_this.currentChoose = _uid;
			// 						//console.log(
			// 							_this.currentModel,
			// 							'_this.currentModel3'
			// 						);
			// 					} else {
			// 						if (res.data[i].childrenList.length > 0) {
			// 							for (
			// 								let j = 0;
			// 								j < res.data[i].childrenList.length;
			// 								j++
			// 							) {
			// 								if (
			// 									res.data[i].childrenList[j]
			// 										.uid == _uid
			// 								) {
			// 									_this.currentModel =
			// 										res.data[i].childrenList[
			// 											j
			// 										].showType;
			// 									_this.currentChoose = _uid;
			// 									//console.log(
			// 										_this.currentModel,
			// 										'_this.currentModel4'
			// 									);
			// 								}
			// 							}
			// 						}
			// 					}
			// 				}
			// 			}
			// 		}
			// 	}
			// });
		},
	},
};
</script>
<style scoped lang="less">
.column {
	width: 100%;
	// height: 100%;
	background: #f2f2f2;
}
.colunm_main_box {
	width: 1300px;
	margin: 0 auto;
	min-height: 600px;
}
.column_top_nav {
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #1a1a1a;
	line-height: 26px;
	height: 54px;
	line-height: 54px;
}
.column_top_nav .active {
	color: #4eac41;
}
.column_center_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 50px;
}
// 左侧导航部分
.column_l_nav_box {
	float: left;
	width: 260px;
	// min-height: 460px;
	padding: 20px;
	background: #fff;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
	position: relative;
	padding-bottom: 232px;
}
.column_l_nav_title {
	width: 260px;
	height: 50px;
	text-align: center;
	line-height: 50px;
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #f7f7f7;
	background: url('../../assets/main/titlebg.png') no-repeat center;
	background-size: cover;
	margin-bottom: 20px;
}
.column_l_nav_title2 {
	width: 260px;
	height: 50px;
	line-height: 50px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #439238;
	margin-bottom: 10px;
	margin-top: 10px;
	border-bottom: 1px solid #439238;
	font-size: 16px;
	text-align: center;
}
.column_l_nav_item {
	background: #f2f2f2;
	margin-bottom: 8px;
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #3f433f;
}
.column_l_nav_img {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
}
.column_l_nav_style1 {
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	// color: #3F433F;
}
.column_l_nav_style2 {
	border-bottom: 1px solid #f3f3f3;
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #8c8c8c;
}
.column_l_nav_style3 {
	font-size: 13px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
}
.column_l_nav_style3:hover {
	color: #4eac41;
}

// 右侧显示部分
.column_r_box {
	float: right;
	width: 950px;
	// padding:14px 30px;
	min-height: 578px;
	// background: #FFFFFF;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
}
/deep/ .inline-input {
	margin-bottom: 17px;
	.el-input {
		margin-bottom: 17px;
	}
	.el-input__inner {
		width: 258px;
		background: #ececec;
		border: 1px solid #c5c5c5;
		// margin-bottom: 17px;
		// border: none !important;
		border-radius: 0px !important;
		height: 35px !important;
		line-height: 35px !important;
		color: #999999 !important;

		font-size: 14px;
	}
	::placeholder {
		font-size: 14px;
		color: #999999; /* 将颜色更改为您想要的颜色值 */
	}
	.el-input__suffix {
		// height: 0;
	}
	.el-input__icon {
		line-height: 35px;
		cursor: pointer;
	}
}
.my-autocomplete {
	li {
		line-height: normal;
		padding: 7px;

		.name {
			text-overflow: ellipsis;
			overflow: hidden;
		}
		.addr {
			font-size: 12px;
			color: #b4b4b4;
		}

		.highlighted .addr {
			color: #ddd;
		}
	}
}
.timelist {
	margin-top: 25px;
	padding-left: 30%;
	p {
		border-left: 1px solid #cfd3da;
		height: 72px;
		position: absolute;
		top: 20px;
		left: 14px;
	}
	li + li {
		margin-top: 60px;
	}
	li {
		position: relative;
		cursor: pointer;
		padding-left: 42px;
	}
	li:last-child p {
		border-left: 0;
	}
	li:hover {
		.classA {
			font-weight: bold;
			font-size: 18px;
			color: #238c3e;
			line-height: 24px;
		}
		background: url(../../assets/hot/point_hover1.png) no-repeat 5px 3px;
	}
}
.redbg {
	.classA {
		font-weight: bold;
		font-size: 18px;
		color: #238c3e;
		line-height: 24px;
	}
	background: url(../../assets/hot/point_hover1.png) no-repeat 5px 3px;
}
.blackbg {
	.classA {
		font-size: 18px;
		color: #333333;
		line-height: 24px;
	}
	background: url(../../assets/hot/point1.png) no-repeat 5px 3px;
}
</style>



// WEBPACK FOOTER //
// src/view/hotcolumn/index.vue